export default __webpack_public_path__ + "static/media/separator1-img3.80d17dcd.png";